/**
 * DOM Initializer Module
 * Khởi tạo và bind tất cả DOM events
 */

import * as StateManager from '../shared/state-manager.js';
import { validatePhoneNumber } from '../shared/validator.js';
import { saveCustomerInfo, clearSubmittedHash } from '../shared/storage-service.js';

// Dependencies - will be injected
let addCourseToSelection, removeCourse, changeVariation;
let handleSubmitRegistration, handleDirectSubmitRegistration, handleDirectSubmitWithPayment, handleTrialPayment, handlePrintQuote, showAllCampaignsPopup;
let checkCustomerExists, applyBestCampaign;

export function injectDependencies(deps) {
    addCourseToSelection = deps.addCourseToSelection;
    removeCourse = deps.removeCourse;
    changeVariation = deps.changeVariation;
    handleSubmitRegistration = deps.handleSubmitRegistration;
    handleDirectSubmitRegistration = deps.handleDirectSubmitRegistration;
    handleDirectSubmitWithPayment = deps.handleDirectSubmitWithPayment;
    handleTrialPayment = deps.handleTrialPayment;
    handlePrintQuote = deps.handlePrintQuote;
    showAllCampaignsPopup = deps.showAllCampaignsPopup;
    checkCustomerExists = deps.checkCustomerExists;
    applyBestCampaign = deps.applyBestCampaign;
}

/**
 * Initialize all DOM event bindings
 */
export function initializeDOMEvents() {
    const $ = jQuery;
    const $cache = StateManager.getCache();

    // Dropdown add (keep for compatibility)
    $('#ktvhvn-course-select').on('change', async function() {
        const courseId = parseInt($(this).val(), 10);
        if (courseId) {
            await addCourseToSelection(courseId);
        }
        $(this).val('');
    });

    // Scroll helper for empty state CTA
    $('#ktvhvn-empty-cta').on('click', function() {
        const picker = $('#ktvhvn-course-picker');
        if (picker.length) {
            $('html, body').animate({
                scrollTop: picker.offset().top - 20
            }, 400);
            $('#ktvhvn-course-select').focus();
        }
    });

    // Popup actions
    $('#ktvhvn-confirm-registration').on('click', handleSubmitRegistration);

    // Payment section actions
    $('#ktvhvn-submit-registration-top').on('click', handleDirectSubmitRegistration); // Direct submit without popup
    $('#ktvhvn-submit-payment-top').on('click', handleDirectSubmitWithPayment); // Shows VietQR payment popup
    $('#ktvhvn-submit-trial-top').on('click', handleTrialPayment);
    $('#ktvhvn-print-quote-btn').on('click', handlePrintQuote);

    // Choose Voucher button - open popup with ALL campaigns
    $('#ktvhvn-choose-voucher-btn').on('click', function() {
        const campaignsCache = StateManager.getCampaignsCache();
        if (campaignsCache) {
            showAllCampaignsPopup(campaignsCache);
        }
    });

    // Apply Best Promo button - automatically apply best campaign
    $('#ktvhvn-apply-best-promo-btn').on('click', function() {
        applyBestCampaign();
    });

    $('.ktvhvn-popup-close, .ktvhvn-popup-overlay').on('click', function() {
        $(this).closest('.ktvhvn-popup').hide();
    });

    // Variation selector change
    $(document).on('change', '.ktvhvn-variation-select', function() {
        const courseIndex = parseInt($(this).data('index'), 10);
        const variationId = parseInt($(this).val(), 10);
        changeVariation(courseIndex, variationId);

        // Update info button with new description
        const variationsData = $(this).data('variations');
        if (variationsData) {
            const newDescription = variationsData[variationId] || '';
            const $infoBtn = $(this).siblings('.ktvhvn-variation-info-btn');

            if (newDescription && newDescription.trim() !== '') {
                if ($infoBtn.length) {
                    // Update existing button
                    $infoBtn.attr('data-description', newDescription);
                } else {
                    // Add new button if it doesn't exist
                    $(this).after(`
                        <button type="button" class="ktvhvn-variation-info-btn" data-description="${newDescription}" title="Xem mô tả">
                            <i class="fa fa-question-circle"></i>
                        </button>
                    `);
                }
            } else {
                // Remove button if no description
                $infoBtn.remove();
            }
        }
    });

    // Variation info button click - show description popup
    $(document).on('click', '.ktvhvn-variation-info-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const description = $(this).attr('data-description');
        showVariationDescriptionPopup(description, $(this));
    });

    // Variation info button hover for desktop
    let hoverTimeout;
    $(document).on('mouseenter', '.ktvhvn-variation-info-btn', function() {
        const $btn = $(this);
        const description = $btn.attr('data-description');

        // Only show on desktop (min-width 769px)
        if ($(window).width() > 768) {
            hoverTimeout = setTimeout(function() {
                showVariationDescriptionTooltip(description, $btn);
            }, 300); // Show after 300ms hover
        }
    });

    $(document).on('mouseleave', '.ktvhvn-variation-info-btn', function() {
        clearTimeout(hoverTimeout);
        $('.ktvhvn-variation-tooltip').remove();
    });

    // Save customer info when changed
    $('#ktvhvn-name, #ktvhvn-phone, #ktvhvn-email, #ktvhvn-note').on('change', function() {
        saveCustomerInfo();
        clearSubmittedHash();
    });

    // Remove error class only when user starts typing
    $('#ktvhvn-name, #ktvhvn-phone, #ktvhvn-email, #ktvhvn-note').on('input', function() {
        $(this).removeClass('ktvhvn-field-error');
        // Also hide error message for phone
        if ($(this).attr('id') === 'ktvhvn-phone') {
            $('#ktvhvn-phone-error').hide();
        }
    });

    // Validate phone number on blur and check if customer exists
    $cache.phone.on('blur', function() {
        const isValid = validatePhoneNumber();
        if (isValid) {
            const checkCustomerTimeout = StateManager.getCheckCustomerTimeout();
            clearTimeout(checkCustomerTimeout);
            const newTimeout = setTimeout(function() {
                checkCustomerExists();
            }, 500);
            StateManager.setCheckCustomerTimeout(newTimeout);
        }
    });

    // Remove item
    $(document).on('click', '.ktvhvn-remove-course', async function() {
        const index = parseInt($(this).data('index'), 10);
        await removeCourse(index);
    });

    // Related card add
    $(document).on('click', '.ktvhvn-related-add', async function(e) {
        e.preventDefault();
        const productId = parseInt($(this).data('product-id'), 10);
        let variationId = 0;

        const variationInput = $(`input[name="related-var-${productId}"]:checked`);
        if (variationInput.length) {
            variationId = parseInt(variationInput.val(), 10);
        }

        await addCourseToSelection(productId, variationId);
    });

    /**
     * Show variation description popup (mobile & desktop click)
     */
    function showVariationDescriptionPopup(description, $btn) {
        // Remove any existing popups
        $('.ktvhvn-variation-popup').remove();

        if (!description || description.trim() === '') {
            return;
        }

        const popupHtml = `
            <div class="ktvhvn-variation-popup">
                <div class="ktvhvn-variation-popup-overlay"></div>
                <div class="ktvhvn-variation-popup-content">
                    <button type="button" class="ktvhvn-variation-popup-close">&times;</button>
                    <div class="ktvhvn-variation-popup-body">
                        ${description}
                    </div>
                </div>
            </div>
        `;

        $('body').append(popupHtml);
        $('.ktvhvn-variation-popup').fadeIn(200);

        // Close popup handlers
        $('.ktvhvn-variation-popup-close, .ktvhvn-variation-popup-overlay').on('click', function() {
            $('.ktvhvn-variation-popup').fadeOut(200, function() {
                $(this).remove();
            });
        });
    }

    /**
     * Show variation description tooltip (desktop hover only)
     */
    function showVariationDescriptionTooltip(description, $btn) {
        // Remove any existing tooltips
        $('.ktvhvn-variation-tooltip').remove();

        if (!description || description.trim() === '') {
            return;
        }

        const tooltipHtml = `
            <div class="ktvhvn-variation-tooltip">
                <div class="ktvhvn-variation-tooltip-arrow"></div>
                <div class="ktvhvn-variation-tooltip-content">
                    ${description}
                </div>
            </div>
        `;

        $('body').append(tooltipHtml);

        const $tooltip = $('.ktvhvn-variation-tooltip');
        const btnOffset = $btn.offset();
        const btnWidth = $btn.outerWidth();
        const btnHeight = $btn.outerHeight();
        const tooltipWidth = $tooltip.outerWidth();
        const tooltipHeight = $tooltip.outerHeight();

        // Position tooltip above the button
        let top = btnOffset.top - tooltipHeight - 10;
        let left = btnOffset.left + (btnWidth / 2) - (tooltipWidth / 2);

        // Make sure tooltip doesn't go off screen
        if (left < 10) {
            left = 10;
        }
        if (left + tooltipWidth > $(window).width() - 10) {
            left = $(window).width() - tooltipWidth - 10;
        }

        // If tooltip goes above viewport, show below button instead
        if (top < 10) {
            top = btnOffset.top + btnHeight + 10;
            $tooltip.addClass('ktvhvn-variation-tooltip--below');
        }

        $tooltip.css({
            top: top + 'px',
            left: left + 'px'
        });

        $tooltip.fadeIn(150);
    }
}
